// src/components/SectionSelector.jsx
import React, { useMemo } from 'react';

export default function SectionSelector({
  sales,
  selectedSaleId,
  setSelectedSaleId,
  sections,
  selectedSectionId,
  setSelectedSectionId,
  handleViewAll,
  formatSaleDate,
}) {
  const sortedSales = useMemo(() => {
    return [...sales].sort((a, b) => {
      const aTime = new Date(a?.start_date || 0).getTime();
      const bTime = new Date(b?.start_date || 0).getTime();
      return bTime - aTime;
    });
  }, [sales]);

  return (
    <>
      {/* SALE SELECTOR */}
      <div className="mb-4 flex justify-center">
        <div className="w-auto max-w-xs">
          <label htmlFor="sale-select" className="block text-sm font-medium text-gray-700 mb-2 text-center">
            Select Active Sale:
          </label>
          <select
            id="sale-select"
            value={selectedSaleId}
            onChange={(e) => setSelectedSaleId(e.target.value)}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="">-- Select an Active Sale --</option>
            {sortedSales.map((sale) => (
              <option key={sale.id} value={sale.id}>
                {sale.sale_name} ({formatSaleDate(sale.start_date)})
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* SECTION SELECTOR (only when sale selected) */}
      {selectedSaleId && (
        <div className="mb-4 flex justify-center">
          <div className="w-auto max-w-xs">
            <label htmlFor="section-select" className="block text-sm font-medium text-gray-700 mb-2">
              Select Section:
            </label>
            <select
              id="section-select"
              value={selectedSectionId}
              onChange={(e) => setSelectedSectionId(e.target.value)}
              className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              <option value="all">All Sections</option>
              {sections.map((section) => (
                <option key={section.id} value={section.id}>
                  {section.name} 🏷️
                </option>
              ))}
            </select>
            <button
              onClick={handleViewAll}
              className="mt-2 text-sm text-indigo-600 hover:text-indigo-500"
            >
              View All Sections
            </button>
          </div>
        </div>
      )}
    </>
  );
}
